var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdminGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_book",
    transform: "translate(-2097 -414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "book-solid",
    d: "M15.75,12.656V.844A.842.842,0,0,0,14.906,0H3.375A3.376,3.376,0,0,0,0,3.375v11.25A3.376,3.376,0,0,0,3.375,18H14.906a.842.842,0,0,0,.844-.844v-.562a.85.85,0,0,0-.313-.657,7.84,7.84,0,0,1,0-2.626.838.838,0,0,0,.313-.654ZM4.5,4.711A.212.212,0,0,1,4.711,4.5h7.453a.212.212,0,0,1,.211.211v.7a.212.212,0,0,1-.211.211H4.711A.212.212,0,0,1,4.5,5.414Zm0,2.25a.212.212,0,0,1,.211-.211h7.453a.212.212,0,0,1,.211.211v.7a.212.212,0,0,1-.211.211H4.711A.212.212,0,0,1,4.5,7.664Zm8.909,8.789H3.375a1.125,1.125,0,0,1,0-2.25H13.409A12.657,12.657,0,0,0,13.409,15.75Z",
    transform: "translate(2099 414.882)",
    fill: "#72383D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_813",
    "data-name": "\\u9577\\u65B9\\u5F62 813",
    width: 20,
    height: 20,
    transform: "translate(2097 414)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdminGuide);
export default __webpack_public_path__ + "static/media/icon_admin_guide.9c0d0cc7149eaaf6b016426f69dda535.svg";
export { ForwardRef as ReactComponent };